import type { PilotTab } from "web_myplann/Utils/WebViewModel";

export const getActiveTabFromPath = (pathname: string): PilotTab => {
	if (pathname.includes("/portfolio") || pathname.includes("/property")) {
		return "WebPortfolio";
	}
	if (pathname.includes("/goals")) {
		return "GoalsScreen";
	}
	if (pathname.includes("/advisor")) {
		return "WebAdvisor";
	}
	if (pathname.includes("/profile")) {
		return "MoreScreen";
	}
	return "WebDashboard";
};
